import { useParams } from "react-router-dom";
import useApi from "../hooks/useApi";
import { getActividadById } from "../services/api";
import BenMaracas from "./assets/img/imagenes actividad especifica/BenMaracas.jpeg";
import ImgActivEsp from "./assets/img/imagenes actividad especifica/ImgActivEsp.jpeg";
import "./ActividadEspecifica.css";

function ActividadDetalle() {
  const { id } = useParams();
  const { data: actividad, loading } = useApi(() => getActividadById(id), [id]);

  if (loading) {
    return (
      <div className="actividadespecifica">
        <div className="actividadespecifica-wrapper">
          <h1 className="actividadespecifica-title">Cargando actividad...</h1>
        </div>
      </div>
    );
  }

  if (!actividad) {
    return (
      <div className="actividadespecifica">
        <img src={BenMaracas} alt="" className="img-actividadespecifica" />
        <div className="actividadespecifica-wrapper">
          <h1 className="actividadespecifica-title">Maracas de la tierra</h1>
          <div className="actividadespecifica-descripciones">
            <h3 className="actividadespecifica-descripcion">Descubre una forma divertida y consciente de pasar tiempo en familia. Con las maracas de la tierra, los más pequeños podrán crear su propio instrumento musical usando materiales reciclados, mientras aprenden sobre el ritmo, la naturaleza y el valor de cuidar lo que nos rodea.</h3>
          </div>
          <h1 className="actividadespecifica-necesidad">Necesitarás</h1>
          <div className="actividadespecifica-explicaciones">
            <h3 className="actividadespecifica-explicacion">Aquí te dejamos algunas ideas para armar tus maracas de la tierra — pero recuerda que puedes usar lo que tengas en casa y dejar volar tu imaginación.</h3>
          </div>
          <ul className="actividad-lista">
            <li><span>1</span> Botellas plásticas pequeñas o envases reciclados para el cuerpo de las maracas.</li>
            <li><span>2</span> Rollos de papel higiénico o tubos de cartón para los mangos.</li>
            <li><span>3</span> Cinta adhesiva para unir y asegurar las piezas.</li>
            <li><span>4</span> Semillas, piedritas o arroz para darles sonido.</li>
            <li><span>5</span> Hojas secas, flores o pintura para decorarlas con un toque natural.</li>
          </ul>
        </div>
        <div className="actividad-imagen">
          <img src={ImgActivEsp} alt="Materiales necesarios" />
        </div>
      </div>
    );
  }

  return (
    <div className="actividadespecifica">
      {actividad.imagenHero && (
        <img src={actividad.imagenHero} alt={actividad.titulo} className="img-actividadespecifica" />
      )}

      <div className="actividadespecifica-wrapper">
        <h1 className="actividadespecifica-title">{actividad.titulo}</h1>

        <div className="actividadespecifica-descripciones">
          <h3
            className="actividadespecifica-descripcion"
            dangerouslySetInnerHTML={{ __html: actividad.descripcion }}
          />
        </div>

        {actividad.materiales.length > 0 && (
          <>
            <h1 className="actividadespecifica-necesidad">Necesitarás</h1>
            <div className="actividadespecifica-explicaciones">
              <h3 className="actividadespecifica-explicacion">Aquí te dejamos algunas ideas — pero recuerda que puedes usar lo que tengas en casa y dejar volar tu imaginación.</h3>
            </div>
            <ul className="actividad-lista">
              {actividad.materiales.map((m, i) => (
                <li key={i}>
                  <span>{m.numero || i + 1}</span> {m.texto}
                </li>
              ))}
            </ul>
          </>
        )}

        {actividad.archivo && (
          <div className="btn-container">
            <a href={actividad.archivo} className="btn-outline" target="_blank" rel="noopener noreferrer">
              Descargar actividad
            </a>
          </div>
        )}
      </div>

      {actividad.imagenMateriales && (
        <div className="actividad-imagen">
          <img src={actividad.imagenMateriales} alt="Materiales" />
        </div>
      )}
    </div>
  );
}

export default ActividadDetalle;
